import type { OperationsTreeOp } from '../../components/OperationsTree'
import type { MambuConnectionOperation } from '../../lib/types'

export function toTreeOp(op: MambuConnectionOperation): OperationsTreeOp {
  return { operationId: op.id, key: op.key, name: op.name, category: op.category, type: op.type }
}

/**
 * Splits the connection's operations into the main tree and the pinned `Deprecated` group
 * (spec §9-ord). Every Mambu MCP surface — Tenant, Templates, Individual User Access —
 * must split the same way, so the tree looks identical wherever it is rendered.
 *
 * Deprecated operations are shown so an admin can find and disable what the MCP server no
 * longer exposes; they remain non-callable at runtime regardless (`api/v1/runtime.py`).
 */
export function splitOpsForTree(ops: MambuConnectionOperation[]): {
  treeOps: OperationsTreeOp[]
  deprecatedTreeOps: OperationsTreeOp[]
} {
  const treeOps: OperationsTreeOp[] = []
  const deprecatedTreeOps: OperationsTreeOp[] = []
  for (const op of ops) {
    if (op.isDeprecated) deprecatedTreeOps.push(toTreeOp(op))
    else treeOps.push(toTreeOp(op))
  }
  return { treeOps, deprecatedTreeOps }
}
